import { render, staticRenderFns } from "./SubtaskList.vue?vue&type=template&id=bd9115d8&scoped=true&"
import script from "./SubtaskList.vue?vue&type=script&lang=js&"
export * from "./SubtaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9115d8",
  null
  
)

export default component.exports